var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"avatar",class:{ 'avatar--with-image': _vm.hasAvatar }},[(_vm.hasAvatar)?_c('img',{attrs:{"src":_vm.userAvatarUrl}}):[_vm._v(_vm._s(_vm._f("firstLetter")(_vm.userDisplayName)))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }